"use strict";

import {scrollTo, focus} from "./scroll-to"

export function initInScope($scope) {

    let $ajaxForm = $scope.find('.js-ajax-form');

    $ajaxForm.on('success.ajax-form', function() {
        let $wrapper = $(this);
        let offset = 150;
        let $target = $wrapper.find('.js-ajax-form__result');
        scrollTo($target, offset, function () {
            focus($target);
        });
    })
}
